import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { paymentElementOptions } from './stripePaymentElementOptions';
import PaymentTerms from './PaymentTerms';

export default function DonationPaymentForm({
  onSuccess,
  returnUrl,
  buttonClassName = '',
  submitLabel = 'Donate',
  refreshKey = 0,
  onSubmittingChange = () => {},
  submitDisabled = false,
  renderSubmit = null,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [submitting, setSubmittingState] = useState(false);
  const [error, setError] = useState(null);

  const canSubmit = !!stripe && !!elements && !submitting && !submitDisabled;

  const setSubmitting = (value) => {
    setSubmittingState(value);
    onSubmittingChange(value);
  };

  useEffect(() => {
    if (refreshKey && elements) elements.fetchUpdates();
  }, [refreshKey]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setSubmitting(true);
    setError(null);

    const { error: confirmError } = await stripe.confirmPayment({
      elements,
      confirmParams: { return_url: returnUrl },
      redirect: "if_required",
    });

    if (confirmError) {
      setError(confirmError.message);
      setSubmitting(false);
    } else {
      onSuccess();
    }
  };

  return (
    <form onSubmit={handleSubmit} className="donation-payment-form">
      <PaymentElement options={paymentElementOptions()} />
      {error && <div className="donation-error" role="alert">{error}</div>}
      <PaymentTerms submitLabel={submitLabel} />
      {renderSubmit ? renderSubmit({ disabled: !canSubmit, label: submitting ? "Processing…" : submitLabel }) : (
        <button type="submit" className={buttonClassName} disabled={!canSubmit} data-testid="donate-button">
          {submitting ? "Processing…" : submitLabel}
        </button>
      )}
    </form>
  );
}

DonationPaymentForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  returnUrl: PropTypes.string.isRequired,
  buttonClassName: PropTypes.string,
  submitLabel: PropTypes.string,
  refreshKey: PropTypes.number,
  onSubmittingChange: PropTypes.func,
  renderSubmit: PropTypes.func,
  submitDisabled: PropTypes.bool,
};
